import Vue from 'vue'
import VueI18n from 'vue-i18n'
import lotin from './lotin.json'
import kirill from './kirill.json'
import ru from './ru.json'

Vue.use(VueI18n)

const savedLang = localStorage.getItem('lang') || 'lotin'

const messages = {
  lotin,
  kirill,
  ru
}

const i18n = new VueI18n({
  locale: savedLang, // saqlangan til bo‘yicha yuklanadi
  fallbackLocale: 'ru',
  messages
})

export default i18n
